/**
 * Copyright 2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Modal } from "@nordcloud/gnui";
import { useDisclosure } from "~/hooks";
import { SERVICENOW_MSG_PREVIEW_MODAL_TITLE } from "../../constants";
import { CloudCredentialsPreviewMessage } from "../../PreviewMessages";
import { ShortDescriptionField } from "./ShortDescriptionField";
import { StaticDescriptionField } from "./StaticDescriptionField";

const DESCRIPTION =
  "The number of expired cloud accounts will be be located in the description “ServiceNow” field.";

type Props = {
  isReadMode: boolean;
};

export function CloudCredentialsDescriptionSection({ isReadMode }: Props) {
  const { isOpen, close, open } = useDisclosure();

  return (
    <>
      <ShortDescriptionField isReadMode={isReadMode} />
      <StaticDescriptionField description={DESCRIPTION} onPreviewClick={open} />
      <Modal
        isOpen={isOpen}
        actions={[]}
        contentMaxHeight="40rem"
        contentLabel={SERVICENOW_MSG_PREVIEW_MODAL_TITLE}
        onClose={close}
      >
        <CloudCredentialsPreviewMessage />
      </Modal>
    </>
  );
}
